// Copyright (c) 2016 Deere & Company

import DemoRentalHistory from '../../../reports/demo-rental-history/state-connector';

export default {
    component: DemoRentalHistory,
    name: 'DEMO_RENTAL_HISTORY',
    path: 'demo-rental-history'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/demo-rental-history.js